import { Component } from 'react';
import Icon from "@mui/material/Icon/Icon";
import Fab from "@mui/material/Fab";
import FooterFixedOnScreen from '../containers/Layout/FooterFixedOnScreen';

class ActionButtonsActivity extends Component {

    render() {
        return (
            <FooterFixedOnScreen>
                <div className="row">
                    <div className=" col-lg-1 col-md-2 col-sm-4 col-6">
                        <Fab onClick={this.props.driving} className="div-center green-button" id="btn-add-driving">
                            <Icon>directions_car</Icon>
                        </Fab>
                        <span className="floating-btn-text span-center">Roulage</span>
                    </div>
                    <div className="offset-lg-10 col-lg-1 offset-md-8 col-md-2 offset-sm-4 col-sm-4 col-6">
                        <div className="center">
                            <Fab color="primary" className="div-center" id="btn-add-imputation"
                                to="/absences/createAbsence" onClick={this.props.imputation}>
                                <Icon>build</Icon>
                            </Fab>
                            <span className="floating-btn-text span-center">Imputation</span>
                        </div>
                    </div>
                </div>
            </FooterFixedOnScreen>
        );
    }
}

export default ActionButtonsActivity;
